export default __webpack_public_path__ + "static/media/Yahoo_Logo.0af843de.svg";